import script from "./DialogThree.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogThree.vue?vue&type=script&setup=true&lang=js"

import "./DialogThree.vue?vue&type=style&index=0&id=23317987&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23317987"]])

export default __exports__